const implantology = {
  hero: {
    title: "ИМПЛАНТОЛОГИЯ",
    description:
      "Нашата дентална клиника предлага висококачествени, дълготрайни зъбни импланти, които гарантират естествен вид и усещане, съчетавайки се перфектно с естествените ви зъби и значително подобрявайки цялостното ви орално здраве.",
    ctas: {
      bookConsultation: "Запишете Консултация",
      learnMore: "Научете Повече",
    },
    imageAlt: "Съвременни зъбни импланти",
    successRate: {
      title: "98% Успеваемост",
      subtitle: "с нашите съвременни импланти",
    },
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ ЗЪБНИ ИМПЛАНТИ",
    intro:
      "Зъбните импланти предлагат постоянно решение за липсващи зъби с предимства, които надхвърлят естетиката.",
    items: [
      {
        title: "Естествен Вид и Усещане",
        description:
          "Имплантите осигуряват същата стабилност и външен вид като естествените зъби, позволявайки ви да се усмихвате, говорите и храните с увереност.",
      },
      {
        title: "Запазване на Костната Тъкан",
        description:
          "За разлика от традиционните протези, имплантите стимулират костния растеж и предотвратяват загубата на костна тъкан, която настъпва при липса на зъби.",
      },
      {
        title: "Дълготрайно Решение",
        description:
          "При правилна грижа, зъбните импланти могат да издържат цял живот, което ги прави икономически ефективно решение в дългосрочен план.",
      },
    ],
  },
  process: {
    heading: "ПРОЦЕСЪТ НА ИМПЛАНТИРАНЕ",
    intro:
      "Нашият оптимизиран процес осигурява минимален дискомфорт и максимални резултати.",
    steps: [
      {
        title: "Консултация и Планиране",
        description:
          "Започваме с цялостен преглед, използвайки съвременно 3D изображение, за да оценим оралното ви здраве и да създадем персонализиран план за лечение.",
      },
      {
        title: "Поставяне на Импланта",
        description:
          "Използвайки най-съвременна технология, внимателно поставяме титаниевия имплант в челюстната кост, който ще служи като корен за новия ви зъб.",
      },
      {
        title: "Заздравяване и Интеграция",
        description:
          "В период от 3-6 месеца, имплантът се сраства с челюстната ви кост в процес, наречен остеоинтеграция, създавайки стабилна основа.",
      },
      {
        title: "Финална Възстановка",
        description:
          "След като заздравяването приключи, поставяме персонализирана корона, която съответства на естествените ви зъби по цвят, форма и размер.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Получете отговори на често задавани въпроси за зъбните импланти",
    items: [
      {
        question: "Болезнено ли е поставянето на зъбни импланти?",
        answer:
          "Повечето пациенти споделят, че процедурата е по-малко болезнена от очакваното. Използваме съвременна анестезия и седация, за да осигурим вашия комфорт по време на целия процес. Дискомфортът след процедурата обикновено е лек и може да бъде овладян с обикновени болкоуспокояващи.",
      },
      {
        question: "Колко дълго издържат зъбните импланти?",
        answer:
          "При правилна грижа и поддръжка, зъбните импланти могат да издържат цял живот. Короната може да се нуждае от подмяна след 10-15 години поради нормално износване, но самият имплант може да остане интегриран с челюстната ви кост за неопределено време.",
      },
      {
        question: "Подходящ кандидат ли съм за зъбни импланти?",
        answer:
          "Повечето възрастни с добро общо здраве са кандидати за зъбни импланти. Важни фактори са наличието на достатъчна костна плътност за поддържане на импланта, липса на инфекции в устната кухина и здрави венци. По време на консултацията ще оценим вашата конкретна ситуация и ще обсъдим всички възможности.",
      },
      {
        question: "Как да се грижа за моите зъбни импланти?",
        answer:
          "Зъбните импланти изискват същата грижа като естествените зъби: редовно миене, почистване с конец и стоматологични прегледи. Въпреки че не могат да развият кариес, околната венечна тъкан може да се инфектира без правилна устна хигиена, затова поддържането на добри практики за орално здраве е от съществено значение.",
      },
    ],
    cta: "Запишете Вашата Консултация",
  },
};

export default implantology;

